import { pixels } from '@asap-hub/react-components';
import { layoutContentStyles } from '../layout';
const {
  rem
} = pixels;
const components = {
  NavigationLink: {
    styles: {
      svg: {
        fill: 'currentColor'
      }
    }
  },
  Accordion: {
    containerStyles: {
      padding: 0
    },
    itemStyles: {
      margin: 0
    }
  },
  Pill: {
    styles: {
      fontSize: rem(14),
      padding: '4px 8px',
      lineHeight: rem(16),
      maxWidth: 'fit-content'
    }
  },
  TabLink: {
    styles: {
      paddingTop: 0
    },
    layoutStyles: {
      margin: 0
    }
  },
  ExternalLink: {
    styles: {
      margin: 0
    }
  },
  EventPage: {
    containerStyles: layoutContentStyles
  },
  EditModal: {
    bodyStyles: {
      height: '100%',
      boxSizing: 'border-box',
      padding: 0
    },
    styles: {
      display: 'unset'
    }
  },
  ContentPage: {
    styles: {
      padding: 0
    }
  }
};
export default components;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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